import { FC, useEffect } from "react";
import {
  CheckAuthentication,
  UpdateUserLastActionDate,
} from "../../helper/ui/methods";
import { useAppStateContext } from "../../middleware/context/state-context-provider";
import MainNavigationPanel from "../ui/user/main-navigation-panel";
import MainFooterPanel from "../ui/user/main-footer-panel";

export const Services: FC = () => {
  const [state, dispatch] = useAppStateContext();

  useEffect(() => {
    if (state.user === null || state.user === undefined) {
      CheckAuthentication(dispatch);
    }
  }, []);

  useEffect(() => {
    if (state.user) {
      UpdateUserLastActionDate(state.user, dispatch);
    }
  }, [state.user]);

  return (
    <>
      {(() => {
        return (
          <div
            id="pageWrapper"
            onClick={
              state.user
                ? () => UpdateUserLastActionDate(state.user!, dispatch)
                : undefined
            }
          >
            <MainNavigationPanel user={state.user} />
            <div id="contentWrapper">
              <div id="content" className="pageSurface">
                <div id="informationCanvas">
                  <h1>Enhancing Construction Efficiency through BIM</h1>
                  <p>
                    BIM is transforming project management and construction by
                    seamlessly integrating digital modeling and advanced
                    coordination techniques throughout every stage of a
                    project's lifecycle.
                    <br /> At Digital Charcoal, we specialize in BIM
                    Coordination services, harnessing cutting-edge technology to
                    optimize efficiency and precision from initial planning to
                    final execution.
                  </p>
                  <p>
                    At Digital Charcoal, we prioritize delivering exceptional
                    quality at every stage of the project lifecycle. As
                    challenges arise during construction, we provide prompt and
                    effective system design adjustments, utilizing our expertise
                    in BIM processes to implement modifications seamlessly. This
                    adaptability ensures projects stay on schedule, maintain
                    quality, and align with client expectations, upholding both
                    standards and timelines.
                  </p>
                  <h3>Contact Us Today</h3>
                  <p>
                    Talk to us about your project and learn more about our BIM
                    Services.
                  </p>
                </div>
              </div>
            </div>
            <MainFooterPanel />
          </div>
        );
      })()}
    </>
  );
};
